import { render } from "./Congrats.vue?vue&type=template&id=b6d17732"
import script from "./Congrats.vue?vue&type=script&lang=js"
export * from "./Congrats.vue?vue&type=script&lang=js"

import exportComponent from "C:\\task\\cottontriviagame\\markup\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__